import React, {useState} from 'react';
import Select from "react-select";
import {
    bbDictionaryOfCustomHomePages,
    bbDoesCustomerHaveAccessToSubscription, bbFindSubportfolioWithinPortfolio,
    bbFindUserTagsByTagId, bbGetSortedArrayOfSubportfoliosFromPortfolioObject,
    isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import {useDispatch, useSelector} from "react-redux";
import {Tooltip} from "@material-ui/core";
import ComingSoonIconSettings from "./ComingSoonIconSettings";
import {addCustomHomePageTag, setInitUrl, setSubportfolioInView, updateCustomHomePageTag} from "../../../actions";

const CustomSelect = () => {

    // const authUser = useSelector(({auth}) => auth.authUser);
    const {customerInView} = useSelector(({customer}) => customer);
    const {portfolios, subportfolioInView} = useSelector(({breachrisk}) => breachrisk);

    const dispatch = useDispatch();

    const isDisabled = false;
    const textColor = isDisabled ? "text-light-gray" : "";

    const options = [];
    const allCompaniesOption = {value: null, label: "Summary of All Companies"};
    options.push(allCompaniesOption);

    /*  jfd**********22.Dec.01.00:07*****
     *   Portfolio Groups prep
         ********************** `--===<>==<>==C>-< */
    const subportfolios = portfolios && portfolios[customerInView] && portfolios[customerInView].portfolios ? portfolios[customerInView].portfolios : null;

    const arrayOfSubportfolios = subportfolios ? bbGetSortedArrayOfSubportfoliosFromPortfolioObject(portfolios[customerInView]) : null;



    //options needs to have form {value: "", label: ""}
    if(arrayOfSubportfolios && Array.isArray(arrayOfSubportfolios)){
        const groupOptions = arrayOfSubportfolios.map((subPortfolio, index) => {
            return {
                value: subPortfolio.id,
                label: `Group Focus: ${subPortfolio.name}`,
                object: subPortfolio
            }
        });
        options.push(...groupOptions);
    }

    // const [homePage, setHomePage] = useState(customHomePageTags && customHomePageTags.length > 0
    //                                                 ? customHomePageTags[0].definition.description : options[0])

    const currentSubportfolioObjectInView = portfolios
        && portfolios[customerInView]
        && subportfolioInView
            ? bbFindSubportfolioWithinPortfolio(subportfolioInView, portfolios[customerInView])
            : null;
    const currentSubportfolioInViewOption = currentSubportfolioObjectInView
    ? {
        value: currentSubportfolioObjectInView.id,
        label: `Group Focus: ${currentSubportfolioObjectInView.name}`,
        object: currentSubportfolioObjectInView
        }
    : null;
    const [newSubportfolioInViewOption, setNewSubportfolioInViewOption] = useState(currentSubportfolioInViewOption);

    console.log("subportfolioInView is set to", "subportfolioInView", subportfolioInView, "currentSubportfolioObjectInView", currentSubportfolioObjectInView, "currentSubportfolioInViewOption", currentSubportfolioInViewOption, "arrayOfSubportfolios", arrayOfSubportfolios, "options", options, );
    // const hasTags = customHomePageTags && customHomePageTags.length > 0;

    // hasTags && console.log("this is customHome Page Tags", customHomePageTags)

    const handleOnClick = (option) =>{
       if(option){
           dispatch(setSubportfolioInView(
               option.value
           ));
           setNewSubportfolioInViewOption(option);
           console.log("subportfolioInView was set to", option.value);
       } else {
           console.warn("Attempted to set the subportfoio in view but the value from the selector failed initial checks", option);
       }
    }


    return(
        <div className={`px-1 row align-self-center ${textColor}`}>
            <Tooltip title={"Focus on a portfolio group or view all companies in your portfolio."}>
                <>
                        <Select
                            className={"col-12"}
                            options={options}
                            value={subportfolioInView
                            && Array.isArray(options)
                            && options.find(x => x.value === subportfolioInView)
                                ? options.find(x => x.value === subportfolioInView)
                                : allCompaniesOption}
                            onChange={(value) =>handleOnClick(value)}>
                        </Select>

                </>
            </Tooltip>
        </div>


    )
}

export default CustomSelect;